export const sanitizeText = (title: string) => title.replace("\\'", "'")
